export const translations = {
  ANALYTICS_DOWNLOAD_IN_PROGRESS:
    'Your download is in progress. Please do not leave or refresh the page or progress will be canceled.',
  BUCKET_DOES_NOT_EXIST: 'AWS S3 bucket not found.',
  CATEGORY_NOT_FOUND: 'No categories match your search.',
  ERROR_INTERNAL: 'Internal Server Error',
  ERROR_NO_BUCKET_NAME: 'AWS Bucket must include a name.',
  ERROR_NO_TENANT_ID: 'AWS Tenant Not Found.',
  ENDPOINTS_DOWNLOAD_IN_PROGRESS:
    'Your download is in progress. Please do not leave or refresh the page or progress will be canceled.',
  INCORRECT_BUCKET_POLICY: 'AWS S3 access policy is incorrect.',
  NO_POLICY_ON_BUCKET: 'AWS S3 access policy is not set.',
  NO_RESULTS_AVAILABLE: 'There are no results available.',
  POLICY: {
    CAT_SEARCH_PLACEHOLDER: 'Search for a category name',
  },
  S3_BUCKET_NAME_CHAR_LIMIT:
    '*Bucket names must be between 3 to 63 characters long.',
  UNKNOWN_ERROR: 'Something went wrong, please refresh the page.',
  WRONG_BUCKET_REGION: 'AWS S3 Bucket needs to be in Data Residency Region.',
  LOGIN_NEED_HELP:
    'A tenant already exists for this domain, please contact support@dope.security',
  USER_NOT_VERIFIED:
    'Unfortunately, Email is not verified or not in active state.',
  CORPORATE_DOMAIN_REQUIRED:
    'Unfortunately, we only allow corporate domains to sign into dope.security.',
  INVITE_ADMIN_ERROR: 'Error, unable to invite admin',
  UPDATE_INVITED_ADMIN_ERROR: 'Error, unable to update admin',
  DELETE_INVITED_ADMIN_ERROR: 'Error, unable to delete admin',
  GET_ROLES_ERROR: 'Error, Unable to fetch roles',
  UPDATE_INVITED_ADMIN: 'Role successfully updated',
  NOT_ALLOWED_TO_CHANGE_ROLE:
    'You cannot change the permission for your own role',
  REQUIRED_FIELD: 'This field is required.',
  INVALID_EMAIL: 'Invalid Email',
}
